module.exports = __webpack_public_path__ + "img/racecourse-fairview-turf-1800.1693bade.svg";